export enum GenericInputs {
  Input1,
  Input2,
  Input3,
}
